// Persistencia local del CIERRE encolado de una mantención (offline real, v1).
// Gemelo de `offlineMantencionStore` (JSON chico en localStorage), pero con un
// ciclo de vida distinto: sobrevive al PUT del checklist para ejecutar el
// `finish` + envío al reconectar. Un registro por mantención. Best-effort.
const KEY_PREFIX = 'prolift:mantencion-cierre:v1:';
const keyFor = (id) => `${KEY_PREFIX}${id}`;

export function saveCierre(id, cierre) {
  if (id == null) return;
  try {
    localStorage.setItem(keyFor(id), JSON.stringify({ ...cierre, updatedAt: Date.now() }));
  } catch {
    // best-effort
  }
}

export function loadCierre(id) {
  if (id == null) return null;
  try {
    const raw = localStorage.getItem(keyFor(id));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasCierre(id) {
  if (id == null) return false;
  try {
    return localStorage.getItem(keyFor(id)) != null;
  } catch {
    return false;
  }
}

export function updateCierreStatus(id, status, errorMotivo = null) {
  const current = loadCierre(id);
  if (!current) return;
  saveCierre(id, { ...current, status, errorMotivo });
}

export function markFinishDone(id) {
  const current = loadCierre(id);
  if (!current) return;
  saveCierre(id, { ...current, finishDone: true });
}

export function clearCierre(id) {
  if (id == null) return;
  try {
    localStorage.removeItem(keyFor(id));
  } catch {
    // best-effort
  }
}

export function listCierreIds() {
  const ids = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(KEY_PREFIX)) ids.push(key.slice(KEY_PREFIX.length));
    }
  } catch {
    // best-effort
  }
  return ids;
}
